import { render, staticRenderFns } from "./Texto.vue?vue&type=template&id=33b1ed50&scoped=true"
import script from "./Texto.vue?vue&type=script&lang=js"
export * from "./Texto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b1ed50",
  null
  
)

export default component.exports